import { produce } from "immer";

import { generateContent } from "@app/services/zoltar";

// TODO: remove after refactor complete
export const createPromptStorySlice = (set, get) => ({
  story: {},
  promptStoryResponse: null,
  shouldSaveStory: false,
});
